import React, {useEffect, useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import {useLocation} from "react-router-dom";
//local
import {SubscriptionMainInfo} from "./SubscriptionMainInfo";
import {SubscriptionPriceInfo} from "./SubscriptionPriceInfo";
import {SubscriptionStatusRow} from "./SubscriptionStatusRow";
import {openNewTab} from "helpers/helper";
import {subscriptionRelation} from "constants/user.consts";

export const Subscription = ({
  subscription,
  subscriptionsCount,
  changeSubscription,
  getSubscription,
  options,
  currentUser,
  isLoadedOrganizationMembers,
  disableGetButton,
}) => {
  const {t} = useTranslation();
  const location = useLocation();

  const isActive = useMemo(() => subscription.activeStatus, [subscription]);
  const isUserSubscription = useMemo(
    () => subscription.relation === subscriptionRelation.USER,
    [subscription]
  );
  const [purchasedSubscriptionState, setPurchasedSubscriptionState] = useState(undefined);

  const [purchasedMembers, setPurchasedMembers] = useState([]);
  const purchasedMembersCurrentUser = useMemo(
    () =>
      purchasedMembers?.find((member) => member?.id === currentUser?.OrganizationMemberId)
        ?.User ?? {},
    [purchasedMembers, currentUser]
  );
  const handleChangeSubcription = () =>
    subscription.isFake
      ? openNewTab("https://www.handyday.com/contact")
      : changeSubscription(subscription.id, isUserSubscription ? currentUser.id : null);

  // set initial purchased state (before its erasing)
  useEffect(() => {
    !!location.state?.purchasedSubscription &&
      !purchasedSubscriptionState &&
      setPurchasedSubscriptionState({
        name: location.state.purchasedSubscription,
        user: location.state.purchasedUserId,
      });
  }, [purchasedSubscriptionState, location.state]);

  // start opening suscription modal after loading members
  useEffect(() => {
    if (!!purchasedSubscriptionState && isLoadedOrganizationMembers) {
      purchasedSubscriptionState.name === subscription.name &&
        !subscription.isContactUs &&
        changeSubscription(
          subscription.id,
          isUserSubscription ? purchasedSubscriptionState.user ?? null : null
        );
      setPurchasedSubscriptionState(null);
    }
  }, [
    purchasedSubscriptionState,
    subscription.name,
    subscription.id,
    changeSubscription,
    subscription.isContactUs,
    isUserSubscription,
    isLoadedOrganizationMembers,
  ]);

  useEffect(() => {
    isUserSubscription &&
      getSubscription(subscription.id).then(({data}) =>
        setPurchasedMembers(data?.purchasedMembers)
      );
  }, [subscription, getSubscription, isUserSubscription]);

  return (
    <div className={`subscription __${subscriptionsCount}`}>
      <SubscriptionMainInfo
        subscription={subscription}
        options={options}
        isActive={isActive}
        t={t}
      />
      <SubscriptionPriceInfo subscription={subscription} t={t} />
      <SubscriptionStatusRow
        subscription={subscription}
        isActive={isActive}
        user={purchasedMembersCurrentUser}
        members={purchasedMembers}
        disableGetButton={disableGetButton}
        onChange={handleChangeSubcription}
        t={t}
      />
    </div>
  );
};
